var _rect, _line, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 218,
    viewBox: "0 0 280 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 264,
    height: 201.964,
    rx: 23,
    stroke: "black",
    strokeWidth: 16
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 96.8623,
    y1: 3.35329,
    x2: 96.8623,
    y2: 217.964,
    stroke: "black",
    strokeWidth: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129 109C129 110.83 129.732 112.585 131.035 113.879C132.338 115.173 134.105 115.9 135.947 115.9L209.52 115.9L186.594 138.601C185.285 139.9 184.551 141.662 184.551 143.5C184.551 145.337 185.285 147.1 186.594 148.399C187.902 149.698 189.676 150.428 191.526 150.428C193.376 150.428 195.151 149.698 196.459 148.399L231.196 113.899C231.847 113.258 232.364 112.494 232.716 111.654C233.069 110.813 233.251 109.911 233.251 109C233.251 108.089 233.069 107.187 232.716 106.346C232.364 105.506 231.847 104.742 231.196 104.101L196.459 69.601C195.811 68.9576 195.042 68.4473 194.196 68.0991C193.349 67.751 192.442 67.5718 191.526 67.5718C190.61 67.5718 189.703 67.751 188.857 68.0991C188.01 68.4473 187.241 68.9576 186.594 69.601C185.946 70.2443 185.432 71.0081 185.082 71.8487C184.731 72.6892 184.551 73.5902 184.551 74.5C184.551 75.4098 184.731 76.3107 185.082 77.1513C185.432 77.9919 185.946 78.7556 186.594 79.399L209.52 102.1L135.947 102.1C134.105 102.1 132.338 102.827 131.035 104.121C129.732 105.415 129 107.17 129 109Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.0e2496d61b25727c894206186f5f7efb.svg";
export { ForwardRef as ReactComponent };